import { Thing } from 'schema-dts';

import { Image } from '@/lib/types';

import HygraphImage from '@/components/hygraph-image';

import hygraphImageTransformer from '@/hygraph/transformers/hygraph-image.transformer';
import { TSchemaData } from '@/services/schema-service';

ImageRenderer.buildSchema = buildSchema;

function buildSchema(image: Image): Partial<TSchemaData<Thing>> {
  return { images: [image.asset.url] };
}

export default function ImageRenderer(hygraphProps: Image) {
  const props = hygraphImageTransformer(
    hygraphProps.asset,
    hygraphProps.roundedCorners
  );
  if (!props) return null;

  return <HygraphImage {...props} />;
}
